import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from "@mui/material"
import { privacyPage } from "@narvan/legal"

function PrivacyPage() {
  return (
    <>
      <Container style={{ marginBottom: 50 }}>
        <Typography variant="body1" mb={1}>
          {privacyPage.intro}
        </Typography>
        <Typography variant="body2" mb={2}>
          Last Updated: {privacyPage.lastUpdated}
        </Typography>

        {privacyPage.sections.map((section) => {
          return (
            <Box key={section.title}>
              <Accordion
                square={true}
                elevation={0}
                sx={{
                  "&:before": {
                    display: "none",
                  },
                  bgcolor: "secondary.main",
                  mb: 0.4,
                }}
              >
                <AccordionSummary
                  id="panel1-header"
                  aria-controls="panel1-content"
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography color="text.primary">{section.title}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: "secondary.light" }}>
                  <Typography color="text.primary">{section.body}</Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          )
        })}
      </Container>
    </>
  )
}

export default PrivacyPage
